import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcAnalytics = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M3 14.5a1.5 1.5 0 0 1 3 0v5a1.5 1.5 0 0 1-3 0v-5Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M13 12.5a1.5 1.5 0 0 1 3 0v7a1.5 1.5 0 0 1-3 0v-7Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M8 9.5a1.5 1.5 0 1 1 3 0v10a1.5 1.5 0 0 1-3 0v-10Zm10-2a1.5 1.5 0 0 1 3 0v12a1.5 1.5 0 0 1-3 0v-12Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcAnalytics");

export { IcAnalytics };
//# sourceMappingURL=ic-analytics.js.map
